import React, { useState, useEffect } from 'react';
import './CB.css'; 
import Test from "./Test";
import CreateReport from "./CreateReport";
import { API_URL } from './API';

const CircuitBreakerForm = ({ block, plant, instrument, project, goBack, savedGeneralData }) => {
 
  const [preservedData] = useState(() => {
    const saved = localStorage.getItem('circuitBreakerFormData');
    return saved ? JSON.parse(saved) : null;
  });

  const [formData1, setformData1] = useState({
    description: '',
    date: '',
    project: '',
    reportNo: '',
    customer: '',
    client: '',
    location: '',
    make: '',
    ratedFrequency: '',
    serialNumber: '',
    insulationLevel: '',
    productionYear: '',
    closingCoilSupplyVolts: '',
    ratedVoltage: '',
    openingCoilSupplyVolts: '',
    ratedCurrent: '',
    motorSupplyVolts: ''
  });
 
  const [showTestPage, setShowTestPage] = useState(false);
  const [rows, setRows] = useState([]);
  const [generalInspection, setGeneralInspection] = useState({});
  const [savedTestData, setSavedTestData] = useState(null);

  const fetchClientName = async (clientId) => {
    try {
      const response = await fetch(`${API_URL}/clients/get_client`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
      });
      
      if (response.ok) {
        const result = await response.json();
        let clientsData = Array.isArray(result) ? result : result.data || result.clients || [];
        const client = clientsData.find(c => c.client_id === clientId || c.id === clientId);
        return client ? client.client_name : "Unknown Client";
      }
    } catch (error) {
      console.error("Error fetching client details:", error);
    }
    return "Unknown Client";
  };



  useEffect(() => {
  const checkClearFlag = () => {
    const clearFlag = localStorage.getItem('clearCircuitBreakerForm');
    if (clearFlag === 'true') {
     
      setformData1({
        description: '',
        date: '',
        project: '',
        reportNo: '',
        customer: '',
        client: '',
        location: '',
        make: '',
        ratedFrequency: '',
        serialNumber: '',
        insulationLevel: '',
        productionYear: '',
        closingCoilSupplyVolts: '',
        ratedVoltage: '',
        openingCoilSupplyVolts: '',
        ratedCurrent: '',
        motorSupplyVolts: ''
      });
      
     
      localStorage.removeItem('clearCircuitBreakerForm');
      console.log('CircuitBreaker form cleared based on flag');
    }
  };
  
 
  checkClearFlag();
  
  
  const interval = setInterval(checkClearFlag, 500);
  
  return () => clearInterval(interval);
}, []);

useEffect(() => {
 
  if (preservedData) {
    setformData1(preservedData);
  } else if (savedGeneralData?.formData1) {
    setformData1(savedGeneralData.formData1);
  } else {
    const savedData = localStorage.getItem('circuitBreakerFormData');
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        setformData1(parsedData);
      } catch (error) {
        console.error('Error parsing saved form data:', error);
      }
    }
  }
}, [savedGeneralData, preservedData]);

  useEffect(() => {
    const loadProjectData = async () => {
      if (project) {
        let clientName = project?.clientName || project?.client_name;
        
        if (!clientName && project?.client) {
          clientName = await fetchClientName(project.client);
        }
        
        setformData1(prevData => ({
          ...prevData,
          project: project?.name || '',
          client: clientName || '',
        }));
      }
    };
    
    loadProjectData();
  }, [project]);

  useEffect(() => {
    localStorage.setItem('circuitBreakerFormData', JSON.stringify(formData1));
  }, [formData1]);
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    
    switch(name) {
      case 'description':
        newValue = value.replace(/[^a-zA-Z/\s]/g, '');
        break;
      
      case 'customer':
      case 'client':
        newValue = value.replace(/[^a-zA-Z\s]/g, '');
        break;
      
      case 'make':
        newValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
        break;
      
      case 'project':
        newValue = value.replace(/[^a-zA-Z0-9\s,]/g, '');
        break;
      
      case 'ratedFrequency':
      case 'ratedVoltage':
      case 'ratedCurrent':
      case 'serialNumber':
      case 'closingCoilSupplyVolts':
      case 'openingCoilSupplyVolts':
      case 'motorSupplyVolts':
        newValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
        break;
      
      case 'reportNo':
        newValue = value.replace(/[^a-zA-Z0-9\-\s]/g, '');
        break;
      
      case 'location':
        newValue = value.replace(/[^a-zA-Z0-9\-\s,]/g, '');
        break;
      
      case 'insulationLevel':
        newValue = value.replace(/[^a-zA-Z0-9/\s]/g, '');
        break;
      
      case 'productionYear':
        newValue = value.replace(/[^0-9]/g, '').slice(0, 4);
        break;
        
      default:
        break;
    }
  
    setformData1(prevData => ({
      ...prevData,
      [name]: newValue
    }));
  };
  
const handleNextClick = () => {
  console.log("Next button clicked");
  localStorage.setItem('circuitBreakerFormData', JSON.stringify(formData1));
  setShowTestPage(true);
};
  
  const handleBackClick = () => {
    console.log("Back button clicked");
    localStorage.setItem('circuitBreakerFormData', JSON.stringify(formData1));
    if (goBack) {
      goBack();
    }
  };
  
if (showTestPage) {
  return <Test 
    goBack={(data) => {
      setShowTestPage(false);
      if (data?.testData) {
        setSavedTestData(data.testData);
      }
    }} 
    savedGeneralData={{
      formData1,
      rows,
      generalInspection,
      testData: savedTestData || savedGeneralData?.testData,
      contactTestData: savedGeneralData?.contactTestData,
      operationalChecks: savedGeneralData?.operationalChecks
    }} 
  />;
}
 const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {
    
    localStorage.setItem('circuitBreakerFormData', JSON.stringify(formData1));
    localStorage.setItem('openReportsOnLoad', 'true');

      window.location.href = "/";
 
  }
};

  return (
    <div className="CB-00">
      <span 
        style={{ 
          display: 'flex',
          justifyContent: 'flex-end',
          fontSize: '20px', 
          fontWeight: '600', 
          color: '#333', 
          cursor: 'pointer',
          marginLeft: '50px',
          marginBottom: '50px'
        }}
        onClick={redirectToHome}
      >
        X
      </span>

      <div className="CB-01">
        <div className="CB-02">
          <h1 className='CB-03'>Circuit Breaker Inspection / Test (CB)</h1>
        </div>
        <div className="CB-04">
          <div className="CB-05">
            <div className="CB-06">
              <label>Description </label>
              <input 
                type="text" 
                name="description"
                value="CIRCUIT BREAKER INSPECTION / TEST REPORT"
                onChange={handleInputChange}
                placeholder="Enter Description" 
                readOnly
                style={{ cursor: 'not-allowed' }}
              />
            </div>
            <div className="CB-06">
              <label>Date </label>
              <input 
                type="date" 
                name="date"
                value={formData1.date || ''}
                onChange={handleInputChange}
              />
            </div>
            <div className="CB-06">
              <label>Project </label>
              <input 
                type="text" 
                name="project"
                value={formData1.project || ''}
                onChange={handleInputChange}
                placeholder="Enter Project" 
                readOnly
                style={{ cursor: 'not-allowed' }}
              />
            </div>
          </div>

          <div className="CB-05">
            <div className="CB-06">
              <label>Report No </label>
              <input 
                type="text" 
                name="reportNo"
                value={formData1.reportNo || ''}
                onChange={handleInputChange}
                placeholder="Enter Report No" 
              />
            </div>
            <div className="CB-06">
              <label>Customer </label>
              <input 
                type="text" 
                name="customer"
                value={formData1.customer || ''}
                onChange={handleInputChange}
                placeholder="Enter Customer" 
              />
            </div>
            <div className="CB-06">
              <label>Client </label>
              <input 
                type="text" 
                name="client"
                value={formData1.client || ''}
                onChange={handleInputChange}
                placeholder="Enter Client" 
                readOnly
                style={{ cursor: 'not-allowed' }}
              />
            </div>
          </div>

          <div className="CB-05">
            <div className="CB-07">
              <label>Location </label>
              <input 
                type="text" 
                name="location"
                value={formData1.location || ''}
                onChange={handleInputChange}
                placeholder="Enter Location" 
              />
            </div>
          </div>
        </div>
      </div>

      <div className="CB-08">
        <div className="CB-02">
          <h2 className='CB-03'>NAME PLATE DETAILS</h2>
        </div>
        <div className="CB-04">
          <div className="CB-05">
            <div className="CB-06">
              <label>Make </label>
              <input 
                type="text" 
                name="make"
                value={formData1.make || ''}
                onChange={handleInputChange}
                placeholder="Enter Make" 
              />
            </div>
            <div className="CB-06">
              <label>Rated Frequency </label>
              <input 
                type="text" 
                name="ratedFrequency"
                value={formData1.ratedFrequency || ''}
                onChange={handleInputChange}
                placeholder="Enter Rated Frequency " 
              />
            </div>
            <div className="CB-06">
              <label>Serial Number </label>
              <input 
                type="text" 
                name="serialNumber"
                value={formData1.serialNumber || ''}
                onChange={handleInputChange}
                placeholder="Enter Serial Number" 
              />
            </div>
          </div>
          
          <div className="CB-05">
            <div className="CB-06">
              <label>Insulation Level </label>
              <input 
                type="text" 
                name="insulationLevel"
                value={formData1.insulationLevel || ''}
                onChange={handleInputChange}
                placeholder="Enter Insulation Level" 
              />
            </div>
            <div className="CB-06">
              <label>Production Year </label>
              <input 
                type="text" 
                name="productionYear"
                value={formData1.productionYear || ''}
                onChange={handleInputChange}
                placeholder="Enter Production Year " 
              />
            </div>
            <div className="CB-06">
              <label>Closing Coil Supply Volts </label>
              <input 
                type="text" 
                name="closingCoilSupplyVolts"
                value={formData1.closingCoilSupplyVolts || ''}
                onChange={handleInputChange}
                placeholder="Enter Closing Coil Supply Volts " 
              />
            </div>
          </div>
          
          <div className="CB-05">
            <div className="CB-06">
              <label>Rated Voltage </label>
              <input 
                type="text" 
                name="ratedVoltage"
                value={formData1.ratedVoltage || ''}
                onChange={handleInputChange}
                placeholder="Enter Rated Voltage" 
              />
            </div>
            <div className="CB-06">
              <label>Opening Coil Supply Volts </label>
              <input 
                type="text" 
                name="openingCoilSupplyVolts"
                value={formData1.openingCoilSupplyVolts || ''}
                onChange={handleInputChange}
                placeholder="Enter Opening Coil Supply Volts" 
              />
            </div>
            <div className="CB-06">
              <label>Rated Current </label>
              <input 
                type="text" 
                name="ratedCurrent"
                value={formData1.ratedCurrent || ''}
                onChange={handleInputChange}
                placeholder="Enter Rated Current" 
              />
            </div>
          </div>
          
          <div className="CB-05">
            <div className="CB-07">
              <label>Motor Supply Volts </label>
              <input 
                type="text" 
                name="motorSupplyVolts"
                value={formData1.motorSupplyVolts || ''}
                onChange={handleInputChange}
                placeholder="Enter Motor Supply Volts" 
              />
            </div>
          </div>
        </div>
      </div>
      
      <div className="CB-09">
        <button 
          className="CB-10" 
          onClick={handleBackClick}
          type="button"
        >
          Back
        </button>
        <button 
          className="CB-11" 
          onClick={handleNextClick}
          type="button"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default CircuitBreakerForm;